const QUEUE_KEY = 'replog-offline-queue';

// オフラインキューに追加
export const enqueueRecord = (record) => {
  const queue = getQueue();
  queue.push({ ...record, _offlineId: Date.now(), _status: 'pending' });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
};

// キューを取得
export const getQueue = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
};

// キューをクリア
export const clearQueue = () => {
  localStorage.removeItem(QUEUE_KEY);
};

// キューの件数を取得
export const getQueueCount = () => getQueue().length;

// オンライン復帰時にキューを送信
export const flushQueue = async (createRecord) => {
  const queue = getQueue();
  if (queue.length === 0) return 0;

  const results = await Promise.allSettled(
    queue.map((record) => {
      const { _offlineId, _status, ...data } = record;
      return createRecord(data);
    })
  );

  const successCount = results.filter((r) => r.status === 'fulfilled').length;
  if (successCount > 0) clearQueue();
  return successCount;
};